import { ca } from '@cian/analytics';
import { EInteriorDecorationType } from '../../../types/newbuilding/interiorDecoration';

export const trackClickInteriorDecoration = (id: number, type: EInteriorDecorationType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Finishing',
    action: 'click_sopr',
    label: 'jk',
    products: [
      {
        id,
        offerType: 'JK',
        position: 1,
        extra: {
          finishing_type: type,
        },
      },
    ],
  });
};
